

/**
 * url类型
 *
 * @enum {number}
 */
enum urlType {
  remote = 0,           // 远程
  local = 1,            // 本地
}


/**
 *  全局配置样式
 *
 * @interface GlobalDataConfig
 */
interface GlobalDataConfig {
  uploadUrl: string; // 带协议 'https://www.exbb.io/',
  showImgUrl: string; // 本地图片地址 '//img.facemeet.com/',
  urlType: urlType; // 0为oetest,1为本地，2为原来
  domainUrl: string;  // 不带协议 例如 'oetest.joyrry.com',
  domainUrl2: string;  // 不带协议 例如 'oetest.joyrry.com',
  googleKey: string;
  mqttHost: string;
}

export const globalData: GlobalDataConfig = {

  // url: '/api',
  uploadUrl: 'https://www.exbb.io/',
  showImgUrl: '//img.facemeet.com/',
  urlType: 0, // 0为oetest,1为本地，2为原来



  googleKey: 'AIzaSyAEGzjEhgJuiOFf3agSpRZRICO0MfsUjuk',

  domainUrl: process.env.NODE_ENV === 'production' ? 'http://mdm2.imperial-innovations.com:8080' : 'http://mdm2.imperial-innovations.com:8080',
  domainUrl2: process.env.NODE_ENV === 'production' ? 'http://34.96.156.219:8090' : 'http://34.96.156.219:8090',
  mqttHost: "ws://34.96.156.219:3000/"
  // domainUrl: process.env.NODE_ENV === 'production' ? 'http://127.0.0.1:3001' : 'http://127.0.0.1:3001',
  // mqttHost: "ws://127.0.0.1:3000/"
};
